import { gql } from "../../../../__generated__/gql";

export const GET_EDITION = gql(`
query festivalSingalEdition($festivalId: String!) {
  festivalEdition(where: {
    id: $festivalId
  }) {
    id
    name
    year
    availabilityDate
    timezone
  }
}
`);

export const UPDATE_EDITION = gql(`
mutation updateEdition($id:String!, $name: String!, $year:String!, $availabilityDate: String!, $timezone: String!) {
  updateEdition(festival: {
    id: $id,
    name: $name,
    year: $year    
    availabilityDate: $availabilityDate
    timezone: $timezone
}){
    id
}
}
`);
export const DELETE_EDITION = gql(`mutation deleteEdition($editionId: String!) {
  deleteEditionAndBands(editionId: $editionId)
}`);
